import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import OverlayViewModel from '@/ViewModels/Controls/OverlayViewModel';
import Overlay from '@/Controls/Overlay';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';

export default class ImagePreviewFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private OverlayViewModel = ComponentManager.getViewModel<typeof OverlayViewModel>('OverlayViewModel');
    private Overlay = ComponentManager.getControl<typeof Overlay>('Overlay');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');

    /**
     * @override
     */
    public viewModel: OverlayViewModel;

    public constructor(private params: any) {
        super(params);
    }

    /**
     * @override
     */
    control: Overlay;

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = new this.OverlayViewModel({
            isVisible: this.defineComputed(() => {
                let source = ko.unwrap(this.params.source); 
                return source ? true : false;
            }),
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            }),
            isAutoHide: false,
            position: 'bottom',
            isShownOnClick: true,
            isClosedOnClick: true,
            isShownOnHover: false,
            isFocusable: this.isFocusable,
            filter: '.link-view',
            content: this.defineComputed(() => {
                let source = ko.unwrap(this.params.source);

                if (source) {
                    return $('<img src="' + source + '">');
                } else {
                    return '';
                }
            })
        })

        this.control = new this.Overlay(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        return this.jQueryControl;
    }
}

ComponentManager.setFactory('ImagePreview', ImagePreviewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');